import React from "react";

const DEPTH_KEYS = {
  "事业与财富": "career",
  "感情与婚姻": "relationships",
  "健康与身体": "health",
  "财运": "wealth",
  // English labels
  "Career & Wealth": "career",
  "Relationships": "relationships",
  "Health": "health",
  "Family": "family",
};

const SCORE_COLORS = {
  career: "#6B7280",        // metal/gray
  relationships: "#A07820", // earth/gold
  health: "#2D6A4F",        // wood/green
  wealth: "#1E3A8A",        // water/navy
  family: "#A07820",        // earth/gold fallback
};

function domainStars(s) {
  const n = Math.max(1, Math.min(5, Math.round((s||50)/20)));
  return "★".repeat(n) + "☆".repeat(5-n);
}

function DomainCards({ v2Domains, domain_depth, reportNumber, yongElem, xiElem, jiElem, chouElem, tiaohou, setPage, lang, _narratives, age = 30 }) {
  const depthData = domain_depth || {};
  const thConflict = tiaohou?.conflict;
  const thPrimary = tiaohou?.tiaohou_primary || "";
  // Dual-label helper: when tiaohou conflicts, show "引擎用神 · 调候主X"
  const yongLabel = thConflict
    ? (lang==="zh" ? `${yongElem}（结构）· 调候主${thPrimary}` : `${yongElem}(struct) · Tiaohou:${thPrimary}`)
    : yongElem;

  return (
    <div className="lr2-page" id="ch3">
      <div className="lr2-ph">
        <span className="lr2-ph-num">03</span>
        <div>
          <div className="lr2-ph-title">四大领域深度分析</div>
          <div className="lr2-ph-sub">CAREER · RELATIONSHIPS · FAMILY · HEALTH</div>
        </div>
      </div>
      <div className="lr2-dgrid">
        {v2Domains.map((d,i)=>{
          const depthKey = DEPTH_KEYS[d.name] || d.name;
          const depth = depthData[depthKey] || {};
          const scoreColor = SCORE_COLORS[depthKey] || "#A0813C";
          const score = d.score || 60;
          const insights = depth.insights;

          return (
            <div key={i} className="lr2-dcard">
              <div className="lr2-dhead">
                <div className="lr2-dtitle">{d.emoji} {d.name}</div>
                <div className="lr2-dstars">{domainStars(score)}</div>
              </div>
              {/* Score bar */}
              <div style={{marginBottom:10}}>
                <div style={{height:5,background:"#EDE4D0",borderRadius:3,overflow:"hidden"}}>
                  <div style={{
                    height:"100%",
                    width:`${Math.min(100,score)}%`,
                    background:scoreColor,
                    borderRadius:3,
                    transition:"width .8s ease",
                  }}/>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                  <span style={{fontFamily:"sans-serif",fontSize:9,color:"#9A8070"}}>0</span>
                  <span style={{fontFamily:"sans-serif",fontSize:9,color:"#9A8070"}}>{score}/100</span>
                </div>
              </div>
              <div className="lr2-dbody">
                {/* Insights from domain_depth or fallback to narrative */}
                {insights && insights.length > 0 ? (
                  <ul style={{paddingLeft:0,margin:"0 0 8px",listStyle:"none"}}>
                    {insights.map((ins,j)=>(
                      <li key={j} style={{display:"flex",gap:6,marginBottom:5,fontSize:13,color:"#333",lineHeight:1.75}}>
                        <span style={{color:scoreColor,flexShrink:0,marginTop:2}}>·</span>
                        <span>{ins}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>{d.narrative}</p>
                )}
                {/* Element influence badge — dual label when tiaohou conflict */}
                {(depth.element || thConflict) && (
                  <div style={{
                    display:"inline-block",
                    background:"rgba(245,200,66,.10)",
                    border:"1px solid rgba(245,200,66,.3)",
                    borderRadius:12,
                    padding:"3px 10px",
                    fontSize:11,
                    color:"#846B32",
                    fontFamily:"sans-serif",
                    marginBottom:6,
                  }}>
                    用神方向：{yongLabel}
                  </div>
                )}
                {/* Timing alignment */}
                {depth.timing && (
                  <div style={{fontSize:11,color:"#9A8070",fontFamily:"sans-serif",marginBottom:6,lineHeight:1.6}}>
                    {depth.timing}
                  </div>
                )}
                {/* Action recommendation */}
                {depth.action && (
                  <div className="lr2-dkey"><strong>行动建议：</strong>{depth.action}</div>
                )}
                {/* Fallback key insight if no depth data */}
                {!depth.action && d.key && (
                  <div className="lr2-dkey"><strong>关键提示：</strong>{d.key}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {age >= 18 && (
      <div className="lr2-vajra">
        {(() => {
          const VAJRA_EVENT = {
            "水": "度母法会（增益滋养·补水润木）",
            "木": "禅修共修（扎根固本·木气生发）",
            "火": "大圆满开示（智慧光明·火行调伏）",
            "土": "藏医养生（调理脾胃·土行中和）",
            "金": "普巴净障（破除阻碍·金行疏通）",
          };
          // Dynamic description based on element's role (用神/喜神/忌神/仇神)
          const buildDesc = (elem) => {
            if (elem === yongElem) {
              return `${elem}元素是你最需要补充的能量，${VAJRA_EVENT[elem] || "对应法会"}与你的用神方向天然共振——不是宗教义务，而是能量场的协同练习。`;
            }
            if (elem === xiElem) {
              return `${elem}元素助你生长扩展，${VAJRA_EVENT[elem] || "对应法会"}帮你巩固喜神方向、稳定能量场。`;
            }
            if (elem === jiElem) {
              return `${elem}为忌神时容易积累阻碍，${VAJRA_EVENT[elem] || "对应法会"}帮你清理旧账、扫除障碍。`;
            }
            if (elem === chouElem) {
              return `${elem}过旺易致身心沉重，${VAJRA_EVENT[elem] || "对应法会"}帮你调和化解、恢复轻盈。`;
            }
            return `${elem}元素与你的用神方向共振，${VAJRA_EVENT[elem] || "对应法会"}帮你能量调和。`;
          };
          const eventName = VAJRA_EVENT[yongElem] || VAJRA_EVENT["水"];
          const desc = buildDesc(yongElem);
          // Tiaohou conflict: add secondary recommendation
          const thEventName = thConflict && thPrimary ? (VAJRA_EVENT[thPrimary] || "") : "";
          const thDesc = thConflict && thPrimary
            ? `同时，调候视角主${thPrimary}——${thEventName || thPrimary + "行对应修持"}可作为辅助方向。`
            : "";
          return (<>
            <div className="lr2-vajra-head">
              <span className="lr2-vajra-icon">☸</span>
              <div>
                <div className="lr2-vajra-title">能量对治 · 法会修持建议</div>
                <div className="lr2-vajra-sub">
                  {thConflict
                    ? `${lang==="zh"?"你的用神":"Your key element"}: ${yongElem}(${lang==="zh"?"结构":"struct"}) · ${lang==="zh"?"调候":"tiaohou"}: ${thPrimary}`
                    : `${lang==="zh"?"你的用神":"Your key element"}: ${yongElem||"水"} · ${lang==="zh"?"推荐匹配":"match"}: ${eventName}`
                  }
                </div>
              </div>
            </div>
            <div className="lr2-vajra-body">
              <p>{desc}</p>
              {thDesc && <p style={{color:"#A0813C",fontSize:11.5}}>{thDesc}</p>}
              <p>参与方式不强制，亦无宗教框架要求。每次法会都附有时区对齐与实时同步。</p>
            </div>
          </>);
        })()}
        <div className="lr2-vajra-tz">🕐 法会时间已自动对齐至 America/Toronto 及您的本地时区</div>
        <button className="lr2-vajra-cta" onClick={()=>setPage&&setPage("vajra")}>查看近期法会 · 免费参加 →</button>
      </div>
      )}
      {["domain_career","domain_relationships","domain_family","domain_health"].map(dk=>{
        const text = _narratives?.[dk];
        const titles = {domain_career:"事业深度解读", domain_relationships:"感情深度解读", domain_family:"家庭深度解读", domain_health:"健康深度解读"};
        if(!text) return null;
        return (
          <div key={dk} style={{marginTop:18}}>
            <div className="lr2-st">{titles[dk]}</div>
            <div style={{fontSize:"13.5px",color:"#333",lineHeight:1.9}}>
              {text.split("\n").filter(Boolean).map((para,i)=>(
                <p key={i} style={{marginBottom:10}}>{para}</p>
              ))}
            </div>
          </div>
        );
      })}
      <div className="lr2-pf"><span className="lr2-pf-label">澄光能量 · {reportNumber}</span><span className="lr2-pf-seal lr2-pf-current">3</span></div>
    </div>
  );
}

export default DomainCards;
